import { createSelector } from "@reduxjs/toolkit";
import { generatePathAward, generatePathCategories } from "../Utils/Routes";

const awardSelector = state => state.awards.awards;

export const selectAwards = createSelector([awardSelector], (stateAwards) => {
    if(!stateAwards) return null;
    
    const awards = Object.values(stateAwards)
                         /* Make a physical object copy */
                         .map((award) => ({ ...award, selected: false }))

    // sorting by open for viewing
    awards.sort((a, b) => {
        if (a.openForViewing === b.openForViewing) {
            return b - a;
        } else if (a.openForViewing || !b.openForViewing) {
            return -1;
        } else if (b.openForViewing || !a.openForViewing) {
            return 1;
        }
        return 0;
    })

    // soring by not open for viewing alphabetically
    awards.sort((a, b) => {
        if(a.openForViewing || !b.openForViewing) {
            let titleA = a.title.replace(/\s/g, '').toUpperCase();
            let titleB = b.title.replace(/\s/g, '').toUpperCase();
            return titleA.localeCompare(titleB);
        }
        return 0;
    })
    // Sorting by number of Entries 0
    awards.sort((a, b) => {
        return ((a.numEntries < 1) === (b.numEntries < 1))? 0 : a.numEntries<1? 1 : -1;
    })
    return awards.map((award) => {
        /* Prepare and format any data to be ready for printing */
        award.urlNextTo = award.hasCategoryPage ? generatePathCategories(award.awardId) : generatePathAward(award.awardId);
        return award
    });
});

export const selectAvailableAwards = (state) => {
    return selectAwards(state)
            .filter(award => award.numEntries > 0 && award.openForViewing);
}

export const selectAwardById = (state, awardId) => {
    return selectAwards(state)
            .find(award => award.awardId === parseInt(awardId));
}